"use strict";
document.addEventListener('DOMContentLoaded', () => {
    const formElement = document.querySelector('form[id="testaviva_signature_registration"]');
    if (formElement) {
        const select = document.querySelector('#testaviva_signature_registration_type');
        const court = document.querySelector('#form_court');
        const renderFields = (value) => {
            if (court) {
                if (value === 'customer' || value === 'free') {
                    court.style.display = 'block';
                    court.querySelector('select').setAttribute('required', 'required');
                }
                else if (value === 'pay') {
                    court.style.display = 'block';
                    court.querySelector('select').setAttribute('required', 'required');
                }
                else {
                    court.style.display = 'none';
                    court.querySelector('select').removeAttribute('required');
                }
            }
        };
        if (select) {
            select.addEventListener('change', (event) => {
                renderFields(event.target.value);
            });
        }
        if (select) {
            renderFields(select.value);
        }
        else {
            if (court) {
                court.style.display = 'block';
                court.querySelector('select').setAttribute('required', 'required');
            }
        }
    }
});
